module.exports = __webpack_public_path__ + "static/media/34.ba9b6407.jpeg";